import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import {
  Product
} from '../../../shared/models/product';
import { ActivatedRoute, Router } from '@angular/router';
import { PublisherService } from '../../../core/services/publisher.service';
import { ProductConstant } from '../product-messages';
import { CatalogListRequest } from '../../../shared/models/product-search-criteria';
import {
  CacheConstant, CMSPages, CMSTemplateNames, Regex
} from '../../../core/constants/app.constant';
import { AddProductToFavRequest, ItemNum } from '../../../shared/models/product';
import { Footer } from '../../../shared/models/footer';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BaseComponent } from '../../../app.base.component';
import { AuthService } from '../../../core/services/auth.service';
import { UntypedFormControl } from '@angular/forms';
import { CmsContent, ContentStructureDetails, MultipleCarousel, StaticPageContent } from '../../../shared/models/cms';
import { CmsService } from '../../../core/services/cms.service';
import * as _ from 'lodash';
import { AppUtilService } from '../../../core/utils/app-util.service';
import {
  AppConfigService as AppConfig,
  AppConfigService
} from '../../../core/services/init/app-config.service';
import { GoogleAnalyticsService } from '../../../core/services/google-analytics.service';
import { ProductSearchUnauthComponent } from '../product-search-unauth/product-search-unauth.component';
import { RoutePrefix } from '../../../core/constants/routes.constant';
import { ViewportScroller } from '@angular/common';
import { HostListener } from '@angular/core';

@Component({
  selector: 'par-product-catalog-list',
  templateUrl: './product-catalog-list.component.html',
  styleUrls: ['./product-catalog-list.component.scss']
})
export class ProductCatalogListComponent extends BaseComponent implements OnInit {
    @ViewChildren('boxWrapper') boxWrappers!: QueryList<ElementRef>;
  //@ViewChild(ProductSearchUnauthComponent) unauthProductSearch: { searchResult: (arg0: any) => void; };
  //@ViewChild('unauthProductSearch', { static: true }) unauthProductSearch: ProductSearchUnauthComponent;
  @ViewChild(ProductSearchUnauthComponent, { static: true }) unauthProductSearch: ProductSearchUnauthComponent;
  /***************Properties***************/
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  websiteName: string = this.envProperties.theme;
  qtyLength = this.envProperties.qtyFieldLength;
  entity = `${this.websiteName + 'Footer'}`;
  footerData: Footer;
  messages = {
    noResultFoundMessage: ProductConstant.Messages.NoSearchResultFoundMessage
  };
  productFilterOptions = {
    sortBy: '',
    direction: '',
    pageSizes: [10, 20, 50, 100],
    selectedPage: 1,
    selectedPageSize: 10
  };
  routes = {
    myhome: RoutePrefix.MyHome
  }
  pagedProductList: Product[] = new Array<Product>();
  tempPagedProductList: Product[] = new Array<Product>();
  productList: Product[] = new Array<Product>();
  noProductsFound: Boolean = true;
  showProductOptions: boolean;
  showSpinner: boolean;
  productsLoaded: Boolean = false;
  enableAddToCart: Boolean = false;
  productsOnAddToCart: Boolean = false;
  productsHideOrShow: boolean = true;

  searchCriteria: CatalogListRequest = {
    buId: this.envProperties.buId,
    page: 0,
    pageSize: 10,
    searchVal: '',
    shipToNum: null,
    soldToNum: null
  };

  caseQtyMismatch = [];
  addProductToFavRequest: AddProductToFavRequest;
  userDetailNum: null;
  favLists: any;
  item: ItemNum;
  caseAlertObject: any;
  isAuthenticated = false;
  searchProduct: UntypedFormControl = new UntypedFormControl();
  cmsPageName: any;
  templateNum: any;

  buId = this.envProperties.buId;
  carousel: MultipleCarousel = null;
  cmsSlides: HTMLCollectionOf<HTMLElement>;
  cmsDots: HTMLCollectionOf<HTMLElement>;
  cmsSlideIndex = 0
  slideIndex = 0;
  slideClick: boolean = false;
  timeOutIDs: any;
  ctaPageName: any;
  ctaTemplateNum: any;
  callToActionArrays: any;
  contentArr: any[];
  content: any;
  productSearch: any = "";
  search = {
    type: null,
    option: null,
    operand: null,
    value: null,
    isAdvance: null
  };
  searchBarDisabled: boolean = true;
  catalogFilterBy: string = null;
  productRadioButton: any;
  isHidden: boolean = false;
  showCurrentCustomer: boolean = false;
  downloadCatalog: boolean = false;
   activeCategory:string|null=null;
  categories=[
  ]
  selectedRole:string|null=null
  ProductsRow:any;
  KeepRow:any;
  LearnRow:any;
  toBuy=[];
  consumersData=[];
  homepageImageContent:  any[]= [];
  isDownloadProduct:boolean=false;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    private router: Router,
    deviceDetectorService: DeviceDetectorService,
    private authService: AuthService,
    appConfig: AppConfigService,
    private cmsService: CmsService,
    private config: AppConfig,
    private gAnalytics: GoogleAnalyticsService,
    private route: ActivatedRoute,
    private scroll:ViewportScroller){
    super(deviceDetectorService, cache, appConfig);
    this.footerData = super.getFooterData();

  }

  ngOnInit() {
    this.getCmsContent();
    this.isAuthenticated = this.authService.isAuthenticated();
    // if (this.isAuthenticated == true) {
    //   PublisherService.changeBannerHeader('');
    //   PublisherService.changeBannerContent('');
    //   this.router.navigate([this.routes.myhome]);
    //   return false;
    // }
    
    this.route.params.subscribe(
      (params: any) => {
        if (Object.keys(params).length > 0) {
          this.productSearch = params.searchValue
        }
      }
    );
    if (window.location.pathname == '/product-catalog-list/' + this.productSearch) {
      this.productRadioButton = localStorage.getItem('productRadioKey');
      this.productsHideOrShow = false;
      this.searchBarDisabled = false;
      this.isHidden = true;
    }

    if (this.isAuthenticated == false) {
      // PublisherService.changeBannerHeader('Product Catalog');
      // PublisherService.changeBannerContent(
      //   '<h2>To access our Product Catalog, please select the option that best describes you. </h2>'
      // );
    }

  }
  
  getCmsContent() {
      if(this.isMobileDevice()){
       this.cmsPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
     }
    else{
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
     }
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.userNotificAuthenticatedSeqNo : this.envProperties.cmsPageConfigVO.productCatalogUnauthenticatedSeqNo;
    this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, pageSeqNumber).subscribe((response: any) => {
      if (!response.hasError && response.length > 0) {
        this.content = response
          this.content.forEach((cta: CmsContent) => {
        cta.contentStructure = JSON.parse(cta.contentStructure);
     
      });
        this.content.sort((a, b) => b.contentNum - a.contentNum);
        this.content.forEach((cta: any, i) => {
          if (cta.contentName == CMSTemplateNames.Web_ProductCatalog +" 1"|| cta.contentName == CMSTemplateNames.Mobile_ProductCatalog +" 1")
             {
            this.KeepRow = cta.contentStructure.recordList;
          } else if (cta.contentName == CMSTemplateNames.Web_ProductCatalog+ " 2"|| cta.contentName == CMSTemplateNames.Mobile_ProductCatalog+ " 2") {
            this.LearnRow = cta.contentStructure.recordList;
           
          }
          else if (cta.contentName == CMSTemplateNames.Web_ProductCatalog+ " 3"||cta.contentName == CMSTemplateNames.Mobile_ProductCatalog+ " 3")
             { this.toBuy = cta.contentStructure.recordList; }
        });

      }
    });
  }
  /***************Constructor***************/

  /***************Component Methods***************/
  onProductChange($event) {
    this.selectedRole=$event.target.value;
    localStorage.setItem("productRadioKey", $event.target.value);
    if ($event.target.value == "Current Customer") {
      this.showCurrentCustomer = true;
      this.searchBarDisabled = true;
      this.isHidden = false;
      this.downloadCatalog = false;
    }
    else {
      this.showCurrentCustomer = false;
      this.downloadCatalog = true;
    }
    this.resetCatalogFilterBy();
    this.productsHideOrShow = false;
    this.searchBarDisabled = false;
    if (this.config.gTrackingId) {
      this.gAnalytics.logTypeOfCustomer($event.target.value);
    }
  }

  getCTAContent(e) {
    let contentData: any;
    let documentNum: number;
    if (e.keyCode != 13) {
        contentData = this.isMobileDevice()?this.content.find(item => item.contentName ==CMSTemplateNames.Mobile_ProductCatalog + " 1") : this.content.find(item => item.contentName == CMSTemplateNames.Web_ProductCatalog + " 1")
       if (contentData.contentStructure.recordList.length > 0) {
          documentNum = contentData.contentStructure.recordList[0].documentNum;
        }
      
      this.cmsService.getCmsMediaByDocNum(documentNum).subscribe((res: any) => {
        AppUtilService.redirectToExternalLink(res.mediaLink);

      })
    }
  }
  onSearchChange() {
    this.resetCatalogFilterBy();
    if (this.searchProduct.value) {
      setTimeout(() => {
        this.searchProduct.value.replace(
          Regex.RestrictSpecialChars,
          ''
        );
      }, 50);
    }
  }
  onSearchProductSubmit() {
    this.router.navigate(['/product-catalog-list/' + this.productSearch]);
    if (this.searchBarDisabled != true && this.productSearch != "" && this.productSearch.toString().trim()) {
      this.unauthProductSearch.getProducts(this.productSearch);
      if (this.config.gTrackingId) {
        this.gAnalytics.logUnauthSearch(this.productSearch);
      }
    }
  }

  doFilter(filterBy: string = 'O') {
    this.catalogFilterBy = filterBy;
    this.unauthProductSearch.getProductsFilterByCatolog(filterBy);
  }
  resetCatalogFilterBy() {
    this.catalogFilterBy = null;
  }

  showDiv($event) {
    this.isHidden = true;
  }
  showDownloadBtn($event) {
    this.downloadCatalog = true;
    if (this.config.gTrackingId) {
      this.gAnalytics.logTypeOfCurrentCustomer($event.value);
    }
  }
  navigateToTargetLink(cmsContentLinkObj: any) {
    if (!_.isEmpty(cmsContentLinkObj)) {
      this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
    }
  }
  downloadFullProductCatalog() {
    this.isDownloadProduct = true;
  }

  toggleCategory(category: any, i: number) {
    this.activeCategory = category.title;
    category.expand = !category.expand;
    this.setEqualBoxHeights();
  }

  @HostListener('window:resize')
  onResize() {
    this.setEqualBoxHeights();
  }

  setEqualBoxHeights() {
    this.LearnRow.forEach(item => {
      item.minheight = '';
    });

    window.requestAnimationFrame(() => {
      const rowSize = 3;
      const rows = this.getRows(this.LearnRow.slice(1), rowSize);

      rows.forEach((row, rowIndex) => {
        const wrappers = this.boxWrappers
          .toArray()
          .slice(rowIndex * rowSize, rowIndex * rowSize + row.length);

        const expandedWrappers = wrappers.filter((_, idx) => row[idx].expand);
        if (expandedWrappers.length === 0) return;

        const heights = expandedWrappers.map(el => el.nativeElement.clientHeight);
        const maxHeightL = Math.max(...heights);

        row.forEach((item, idx) => {
          if (item.expand) {
            item.minheight = maxHeightL + 'px';
          } else {
            item.minheight = '';
          }
        });
      });
    });
  }

  getRows(arr: any[], rowSize: number): any[][] {
    const rows = [];
    for (let i = 0; i < arr.length; i += rowSize) {
      rows.push(arr.slice(i, i + rowSize));
    }
    return rows;
  }

  cancel() {
    this.isDownloadProduct == false;
  }

  ctaClick(i: number, cmsContentLinkObj: any) {
    this.navigateToTargetLink(cmsContentLinkObj);
  }
   scrollProduct(id){
  if(!this.isDesktopDevice()){
  this.scroll.scrollToAnchor(id);
  }
  }
  /***************Component Methods***************/

  /***************Private Methods***************/

  /***************Private Methods***************/
}
